<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800  pt-10">
    <form class="space-y-8 divide-y divide-gray-700">
      <div class="space-y-8 divide-y divide-gray-700">


        <div>
          <div v-if="!placeDetails" class="flex items-center">
            <h1 class="text-3xl font-semibold text-white">Znajdz miejsce</h1>
          </div>




          <div v-if="placeDetails" class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-10/12 px-3">
              <div class="mt-1">
                <input
                  type="text"
                  v-model="placeDetails.name"
                  name="position"
                  id="position"
                  autocomplete="position"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 text-3xl font-semibold text-white bg-gray-800"
                />
              </div>
            </div>
          </div>



          <div class="mt-1 flex rounded-md shadow-sm"></div>

          <div v-if="placeDetailsFullData" class="flex flex-wrap -mx-3 mt-4">
            <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-3">
              <label
                for="street"
                class="block text-sm font-medium text-gray-200"
                >street</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="placeDetailsFullData.fullAdress.street"
                  name="street"
                  id="street"
                  autocomplete="street"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
              <label
                for="postcode"
                class="block text-sm font-medium text-gray-200"
                >postcode</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="placeDetailsFullData.fullAdress.postcode"
                  name="postcode"
                  id="postcode"
                  autocomplete="postcode"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
              <label for="city" class="block text-sm font-medium text-gray-200"
                >city</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="placeDetailsFullData.fullAdress.city"
                  name="city"
                  id="city"
                  autocomplete="city"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>

          </div>


          <div v-if="placeDetails" class="flex flex-wrap -mx-3 mt-4">
            <div class="sm:mt-0 w-full sm:w-2/5 px-3">
              <label for="lat" class="block text-sm font-medium text-gray-200"
                >position</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="position"
                  name="position"
                  id="position"
                  autocomplete="position"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
          </div>


          <div v-if="placeDetailsFullData" class="mt-6 flex">
              <div class="mt-1">
                <p
                  class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-black bg-yellow-600"
                >★ {{ placeDetailsFullData.rating }}</p>  
              </div>

              <div class="mt-1">
                <p
                  class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-yellow-600"
                >{{ placeDetailsFullData.user_ratings_total }}</p>  
              </div>


              <div class="mt-1">
                <p
                  class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-yellow-600"
                >{{ priceLevel }}</p>  
              </div>




          </div>



          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-3">

              <div style="display: none">
                <input
                  id="pac-input"
                  class="controls"
                  type="text"
                  placeholder="Enter a location"
                />
              </div>
            </div>
          </div>

          <div class="mt-4 sm:flex-none">
            <!-- <button
              @click.prevent="searchPlaces(placeName)"
              class="mt-2 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
            >
              szukaj
            </button> -->
            <button
              v-if="placeDetails && placeDetails.place_id && !placeDetailsFullData"
              @click.prevent="getPlaceDetails(placeDetails.place_id)"
              class="mt-2 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
            >
              Get details 
            </button>
          </div>

          <div v-if="placeDetails" class="py-5 rounded-lg shadow">
            <!-- <h2 class="text-xl font-semibold text-white">
              {{ placeDetails.name }}
            </h2>
            <p class="text-gray-600 mt-2 text-white">
              {{ placeDetails.formatted_address }}
            </p>

            <div class="mt-4">
              <p class="text-gray-600">
                Latitude: {{ placeDetails.geometry.location.lat() }}
              </p>
              <p class="text-gray-600">
                Longitude: {{ placeDetails.geometry.location.lng() }}
              </p>

           
            </div> -->   
            <p class="text-gray-700 mt-2">
                Place ID: {{ placeDetails.place_id }}
            </p> 
          </div>

          

            <div class="mt-4" v-if="placeDetailsFullData">

                <div class="flex flex-wrap">
                <div v-for="photo in placeDetailsFull.photos" :key="photo" class="w-48 h-48 overflow-hidden m-3 relative">
                  <img :src="photo.getUrl({ maxWidth: 1000, maxHeight: 1000 })" class="min-w-full rounded-md min-h-full object-cover object-center" />
                  <div class="absolute bottom-0 right-0 bg-black bg-opacity-50 text-white text-xs p-0 px-1">
                    <div v-html="photo.html_attributions.join(', ')" class="whitespace-nowrap"></div>
                  </div>
                </div>
              </div>


              <!-- <p class="text-gray-600 text-white">
                html: {{ placeDetailsFull.photos }}
              </p> -->


            </div>
        </div>
      </div>


      <div ref="mapElement" class="map" id="map"></div>
      <div id="infowindow-content">
        <span id="place-name" class="title"></span><br />
        <strong>Place ID:</strong> <span id="place-id"></span><br />
        <span id="place-address"></span>
      </div>

      <div class="mt-4 sm:flex-none">
        <p class="text-white">Chińczyk na Estrady Warszawa</p>

        <div v-if="placeDetails">
          <p>placeDetails</p>
          <pre>{{ placeDetails }}</pre>
        </div>

        <div v-if="placeDetailsFull">
          <p>placeDetailsFull</p>
          <pre>{{ placeDetailsFull }}</pre>
        </div>

        <!-- <div v-if="infowindowRef">
              <pre v-pre>{{ JSON.stringify(infowindowRef, null, 2) }}</pre>
            </div>  -->
      </div>
    </form>





    <div class="fixed bottom-0 left-0 w-full p-5 bg-gray-800">
      <div class="flex justify-end items-center">
        <!-- <iconOnly
          :tagsIds="tagsIds"
          @updateNextTag="showNextTag"
          class="mr-3"
        /> -->
        <div class="flex justify-end">
          <button
            @click="goBack"
            type="button"
            class="rounded-md border border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="saveAll"
            class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Save
          </button>
        </div>
      </div>
    </div>



  </div>
</template>

<script setup>
import {
  ref,
  toRaw,
  onMounted,
  watchEffect,
  watch,
  computed,
  transformVNodeArgs,
} from "vue";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();

const placeName = ref("");
const placeDetails = ref(null);
const placeDetailsFull = ref(null);
const placeDetailsFullData = ref(null);




// const convertAddress = (formatted_address) => {
//     const arrayAdress = formatted_address.split(",")
  
//     let country = arrayAdress.pop();
//     let postcodeAndCity = arrayAdress.pop().split(" ");
//     let city = postcodeAndCity[1];
//     let postCode = postcodeAndCity[2];
//     let street = arrayAdress.join(" ").replace(",", "")
  
//     const fullAdress = {
//         street: street,
//         city,
//         postcode: postCode,
//         country,
//         }
  
//     return fullAdress
//   }



watch(placeDetails, () => {
  placeDetailsFullData.value = null;
}, { immediate: true });

watch(placeDetailsFull, (newValue) => {
  if (newValue && newValue.geometry && newValue.geometry.viewport) {
    // Konwersja danych Proxy na zwykły obiekt JS nie jest tutaj potrzebna, gdyż modyfikujemy bezpośrednio placeDetailsFull
    // Jeśli potrzebujesz korzystać z toRaw, użyj go na całym obiekcie, ale tutaj wydaje się być zbędne

    // Upewnij się, że address_components istnieje przed próbą dostępu do jego elementów
    if (newValue.address_components) {
      const stNumber = newValue.address_components[0]?.short_name ?? 'N/A';
      const street = newValue.address_components[1]?.short_name ?? 'N/A';
      const postcode = newValue.address_components[7]?.short_name ?? 'N/A';
      const city = newValue.address_components[4]?.short_name ?? 'N/A';
      const countryCode = newValue.address_components[6]?.short_name ?? 'N/A';
      const positionLat = newValue.geometry.location?.lat ?? 'N/A';
      const positionLng = newValue.geometry.location?.lng ?? 'N/A';
      const price_level = newValue.price_level ?? 'N/A';
      const formatted_address = newValue.formatted_address ?? 'N/A';
      // const fullAdress = convertAddress(formatted_address);


      const  rating = newValue.rating ?? 'N/A';
      const  formatted_phone_number = newValue.formatted_phone_number ?? 'N/A';
      const  international_phone_number = newValue.international_phone_number ?? 'N/A';
      const  adr_address = newValue.adr_address ?? 'N/A';
      const  business_status = newValue.business_status ?? 'N/A';
      const  icon = newValue.icon ?? 'N/A';
      const  name = newValue.name ?? 'N/A';
      const  photos = newValue.photos ?? 'N/A';
      const  place_id = newValue.place_id ?? 'N/A';
      const reviews = newValue.reviews ?? 'N/A';
      const types = newValue.types ?? 'N/A';
      const url = newValue.url ?? 'N/A';
      const vicinity = newValue.vicinity ?? 'N/A';
      const website = newValue.website ?? 'N/A';
      const html_attributions = newValue.html_attributions ?? 'N/A';
      const opening_hours = newValue.opening_hours ?? 'N/A';
      const user_ratings_total = newValue.user_ratings_total ?? 'N/A';



      placeDetailsFullData.value = {
        formatted_address,
        adr_address,

        fullAdress: {
          street: `${street} ${stNumber}`,
          city,
          postcode,
          countryCode,
        },

        position: `${positionLat}, ${positionLng}`,
        price_level,
        rating,
        formatted_phone_number,
        international_phone_number,
        business_status,
        icon,
        name,
        opening_hours,
        photos,
        place_id,
        reviews,
        types,
        url,
        vicinity,
        website,
        html_attributions,
        user_ratings_total,

      };

      console.log("placeDetailsFullData.value 2: ", placeDetailsFullData.value);
    }
  }
}, { immediate: true });


const priceLevel = computed(() => {
  // Sprawdź, czy placeDetailsFullData i placeDetailsFullData.price_level istnieją
  if (placeDetailsFullData.value && placeDetailsFullData.value.price_level != null) {
    // Zwróć ciąg znaków '$' powielony odpowiednią liczbę razy
    return '$'.repeat(placeDetailsFullData.value.price_level);
  }
  return ''; // Zwróć pusty ciąg, jeśli price_level nie jest dostępny
});

const map = ref(null);
const marker = ref(null);
const mapElement = ref(null);
const infowindowRef = ref(null);
const initialPosition = { lat: 52.22977, lng: 21.01178 };

onMounted(() => {
  loadGoogleMapsScript().then(() => {
    initMap();
  });
});

// function initMap() {
//   const mapOptions = {
//     zoom: 13,
//     center: new google.maps.LatLng(initialPosition.lat, initialPosition.lng),
//   };
//   map.value = new google.maps.Map(mapElement.value, mapOptions);
//   marker.value = new google.maps.Marker({
//     position: mapOptions.center,
//     map: map.value,
//     title: 'Hello World!',
//   });
// }

// This sample uses the Place Autocomplete widget to allow the user to search
// for and select a place. The sample then displays an info window containing
// the place ID and other information about the place that the user has
// selected.
// This example requires the Places library. Include the libraries=places
// parameter when you first load the API. For example:
// <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
function initMap() {
  map.value = new google.maps.Map(document.getElementById("map"), {
    center: { lat: initialPosition.lat, lng: initialPosition.lng },
    zoom: 13,
  });
  const input = document.getElementById("pac-input");
  // Specify just the place data fields that you need.
  const autocomplete = new google.maps.places.Autocomplete(input, {
    fields: ["place_id", "geometry", "formatted_address", "name"],
  });

  autocomplete.bindTo("bounds", map.value);
  map.value.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

  const infowindow = new google.maps.InfoWindow();
  infowindowRef.value = infowindow;
  console.log("infowindowRef.value: ", infowindowRef.value);

  const infowindowContent = document.getElementById("infowindow-content");

  infowindow.setContent(infowindowContent);

  const marker = new google.maps.Marker({ map: map.value });

  marker.addListener("click", () => {
    infowindow.open(map.value, marker);
  });
  autocomplete.addListener("place_changed", () => {
    infowindow.close();

    const place = autocomplete.getPlace();

    if (!place.geometry || !place.geometry.location) {
      return;
    }

    if (place.geometry.viewport) {
      map.value.fitBounds(place.geometry.viewport);
    } else {
      map.value.setCenter(place.geometry.location);
      map.value.setZoom(14);
    }

    // Set the position of the marker using the place ID and location.
    // @ts-ignore This should be in @typings/googlemaps.
    marker.setPlace({
      placeId: place.place_id,
      location: place.geometry.location,
    });
    marker.setVisible(true);
    infowindowContent.children.namedItem("place-name").textContent = place.name;
    infowindowContent.children.namedItem("place-id").textContent =
      place.place_id;
    infowindowContent.children.namedItem("place-address").textContent =
      place.formatted_address;
    infowindow.open(map.value, marker);

    console.log("place: ", place);
    placeDetails.value = place;
  });
}

function getPlaceDetails(placeId) {
  const request = {
    placeId: placeId,
    fields: [
      "name",
      "rating",
      "formatted_phone_number",
      "geometry",
      "business_status",
      "address_components",
      "formatted_address",
      "formatted_phone_number",
      "plus_code",
      "icon",
      "opening_hours",
      "photos",
      "place_id",
      "reviews",
      "types",
      "url",
      "vicinity",
      "website",
      "price_level",
      "international_phone_number",
      "adr_address",
      "scope",
      "user_ratings_total",
      "utc_offset_minutes",
      "url",
"serves_beer",
"serves_breakfast",
"serves_brunch",
"serves_dinner",
"serves_lunch",
"serves_vegetarian_food",
"serves_wine",
"takeout",
"editorial_summary",
"dine_in",
"delivery",

    ],
  };

  const service = new google.maps.places.PlacesService(map.value);
  service.getDetails(request, function (place, status) {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      console.log("Place details:", place);
      placeDetailsFull.value = place;
      console.log("placeDetailsFull.value: ", placeDetailsFull.value);
      // createMarker(place); // Załóżmy, że createMarker jest już zdefiniowaną funkcją.
    } else {
      console.error("Place details request failed due to ", status);
    }
  });
}

function loadGoogleMapsScript() {
  return new Promise((resolve) => {
    if (typeof google !== "undefined" && google.maps) {
      resolve();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCiNeI2j5GhrMCeyJcEtCmPxJdejQXr7r0&callback=initMap`;
      script.async = true;
      document.head.appendChild(script);
      window.initMap = () => {
        resolve();
      };
    }
  });
}



const position = computed({
  get: () => {
    // Sprawdź, czy placeDetails.geometry istnieje przed próbą dostępu do lat i lng
    if (placeDetails.value && placeDetails.value.geometry && placeDetails.value.geometry.location) {
      const lat = placeDetails.value.geometry.location.lat();
      const lng = placeDetails.value.geometry.location.lng();
      return `${lat}, ${lng}`;
    }
    return '';
  },
  set: (newValue) => {
    const [lat, lng] = newValue.split(',').map(num => parseFloat(num.trim()));
    // Zakładamy, że masz sposób na aktualizację placeDetails.geometry.location,
    // ale zwykle wartości te są ustawiane przez API Google Maps, więc być może będziesz musiał
    // zaimplementować to inaczej, w zależności od Twoich potrzeb.
    if (!isNaN(lat) && !isNaN(lng)) {
      // Aktualizuj placeDetails.geometry.location, jeśli to konieczne
      // Uwaga: Może być potrzebna dalsza logika do aktualizacji tych wartości
    }
  },
});



// const position = computed({
//   // Getter tworzy string z lat i lng
//   get: () => `${placeDetails?.geometry?.location?.lat()}, ${placeDetails?.geometry?.location?.lng()}`,
//   // Setter aktualizuje lat i lng na podstawie zmienionej wartości position
//   set: (newValue) => {
//     const [lat, lng] = newValue.split(",").map(Number);
//     dane.value.lat = lat;
//     dane.value.lng = lng;
//   },
// });

// const position = computed({
//   get: () => {
//     // Używa opcjonalnego łańcuchowania i operatora nullish coalescing
//     const lat = placeDetails?.geometry?.location?.lat?.() ?? 0;
//     const lng = placeDetails?.geometry?.location?.lng?.() ?? 0;
//     return `${lat}, ${lng}`;
//   },
//   set: (newValue) => {
//     const [lat, lng] = newValue.split(",").map(Number);
//     if (placeDetails && placeDetails.geometry && placeDetails.geometry.location) {
//       // Zakładam, że dane.value to reaktywny obiekt Vue zawierający lat i lng
//       dane.value.lat = lat;
//       dane.value.lng = lng;
//     }
//   },
// });


// {
//     "address_components": [
//         {
//             "long_name": "13D",
//             "short_name": "13D",
//             "types": [
//                 "street_number"
//             ]
//         },
//         {
//             "long_name": "Estrady",
//             "short_name": "Estrady",
//             "types": [
//                 "route"
//             ]
//         },
//         {
//             "long_name": "Warszawa",
//             "short_name": "Warszawa",
//             "types": [
//                 "locality",
//                 "political"
//             ]
//         },
//         {
//             "long_name": "Powiat warszawski zachodni",
//             "short_name": "Powiat warszawski zachodni",
//             "types": [
//                 "administrative_area_level_2",
//                 "political"
//             ]
//         },
//         {
//             "long_name": "Mazowieckie",
//             "short_name": "Mazowieckie",
//             "types": [
//                 "administrative_area_level_1",
//                 "political"
//             ]
//         },
//         {
//             "long_name": "Polska",
//             "short_name": "PL",
//             "types": [
//                 "country",
//                 "political"
//             ]
//         },
//         {
//             "long_name": "05-080",
//             "short_name": "05-080",
//             "types": [
//                 "postal_code"
//             ]
//         }
//     ],
//     "adr_address": "<span class=\"street-address\">Estrady 13D</span>, <span class=\"postal-code\">05-080</span> <span class=\"locality\">Warszawa</span>, <span class=\"country-name\">Polska</span>",
//     "business_status": "OPERATIONAL",
//     "formatted_address": "Estrady 13D, 05-080 Warszawa, Polska",
//     "formatted_phone_number": "532 179 532",
//     "geometry": {
//         "location": {
//             "lat": 52.28877430000001,
//             "lng": 20.8762566
//         },
//         "viewport": {
//             "south": 52.28741726970851,
//             "west": 20.87511831970849,
//             "north": 52.29011523029151,
//             "east": 20.8778162802915
//         }
//     },
//     "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/restaurant-71.png",
//     "international_phone_number": "+48 532 179 532",
//     "name": "Chińczyk na Estrady Warszawa",
//     "opening_hours": {
//         "open_now": true,
//         "periods": [
//             {
//                 "close": {
//                     "day": 0,
//                     "time": "2130",
//                     "hours": 21,
//                     "minutes": 30,
//                     "nextDate": 1709497800000
//                 },
//                 "open": {
//                     "day": 0,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709460000000
//                 }
//             },
//             {
//                 "close": {
//                     "day": 1,
//                     "time": "2130",
//                     "hours": 21,
//                     "minutes": 30,
//                     "nextDate": 1709584200000
//                 },
//                 "open": {
//                     "day": 1,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709546400000
//                 }
//             },
//             {
//                 "close": {
//                     "day": 2,
//                     "time": "2130",
//                     "hours": 21,
//                     "minutes": 30,
//                     "nextDate": 1709670600000
//                 },
//                 "open": {
//                     "day": 2,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709632800000
//                 }
//             },
//             {
//                 "close": {
//                     "day": 3,
//                     "time": "2100",
//                     "hours": 21,
//                     "minutes": 0,
//                     "nextDate": 1709755200000
//                 },
//                 "open": {
//                     "day": 3,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709719200000
//                 }
//             },
//             {
//                 "close": {
//                     "day": 4,
//                     "time": "2130",
//                     "hours": 21,
//                     "minutes": 30,
//                     "nextDate": 1709238600000
//                 },
//                 "open": {
//                     "day": 4,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709805600000
//                 }
//             },
//             {
//                 "close": {
//                     "day": 5,
//                     "time": "2130",
//                     "hours": 21,
//                     "minutes": 30,
//                     "nextDate": 1709325000000
//                 },
//                 "open": {
//                     "day": 5,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709287200000
//                 }
//             },
//             {
//                 "close": {
//                     "day": 6,
//                     "time": "2130",
//                     "hours": 21,
//                     "minutes": 30,
//                     "nextDate": 1709411400000
//                 },
//                 "open": {
//                     "day": 6,
//                     "time": "1100",
//                     "hours": 11,
//                     "minutes": 0,
//                     "nextDate": 1709373600000
//                 }
//             }
//         ],
//         "weekday_text": [
//             "poniedziałek: 11:00–21:30",
//             "wtorek: 11:00–21:30",
//             "środa: 11:00–21:00",
//             "czwartek: 11:00–21:30",
//             "piątek: 11:00–21:30",
//             "sobota: 11:00–21:30",
//             "niedziela: 11:00–21:30"
//         ]
//     },
//     "photos": [
//         {
//             "height": 4000,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/103307062367477538788\">Justyna Karpińska</a>"
//             ],
//             "width": 3000
//         },
//         {
//             "height": 3290,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/105175645571486587432\">pawel pk</a>"
//             ],
//             "width": 4558
//         },
//         {
//             "height": 4032,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/104378662894930567455\">mateusz strzalkowski</a>"
//             ],
//             "width": 3024
//         },
//         {
//             "height": 4032,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/115401672077767466228\">Bartłomiej Wojsa</a>"
//             ],
//             "width": 3024
//         },
//         {
//             "height": 3000,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/105697299651774961479\">Jakub K</a>"
//             ],
//             "width": 4000
//         },
//         {
//             "height": 2592,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/104290413301352820614\">Mateusz Maciejewski</a>"
//             ],
//             "width": 4608
//         },
//         {
//             "height": 4032,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/105334234055329533939\">Paulina Roczek</a>"
//             ],
//             "width": 3024
//         },
//         {
//             "height": 3022,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/103973787512276742887\">Brahrp</a>"
//             ],
//             "width": 4030
//         },
//         {
//             "height": 1712,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/111289599773095547889\">Paulina C</a>"
//             ],
//             "width": 1284
//         },
//         {
//             "height": 3024,
//             "html_attributions": [
//                 "<a href=\"https://maps.google.com/maps/contrib/116259077760182063279\">Grzegorz Knet</a>"
//             ],
//             "width": 4032
//         }
//     ],
//     "place_id": "ChIJRxltNP-1HkcRDNqLZe7uZxA",
//     "plus_code": {
//         "compound_code": "7VQG+GG Warszawa, Polska",
//         "global_code": "9G427VQG+GG"
//     },
//     "price_level": 2,
//     "rating": 4.7,
//     "reviews": [
//         {
//             "author_name": "Szymon Szajda (szymsza1)",
//             "author_url": "https://www.google.com/maps/contrib/106239937106978215659/reviews",
//             "language": "pl",
//             "profile_photo_url": "https://lh3.googleusercontent.com/a-/ALV-UjVjGCg3dzlfl1uMkG9tZMImaLzutTs2uAWF25UxAoc2f40S=s128-c0x00000000-cc-rp-mo-ba6",
//             "rating": 5,
//             "relative_time_description": "tydzień temu",
//             "text": "Po rekomendacji Książula, postanowiłem przetestować to miejsce.\nLokal niepozorny, w środku całkiem przytulnie, dużo roślin, ale to chyba nie jest wystrój zbyt związany z kuchnią chińską. No ale też nie przeszkadza.\nPani za kasą jakaś specyficzna była, sprawiała wrażenie, że nie ogarnia co się dzieje.\nPrzy stoliku inna pani przyniosła nam gratisową herbatkę ziołowo-miętową. A potem przyszło najważniejsze, czyli zamówione dania.\nPorcje ogromne, świeże i bardzo smaczne. Śmiało mogę polecić. Chrupiący kurczak super, dwa duże kotlety. Kurczak w cieście kokosowym też bardzo dobry, duże kawałki kurczaka i smaczne ciasto. Do tego dobry ryż, pyszna surówka z kapusty i smażone (grillowane?) warzywa. Całość bardzo sycąca i smaczna. Polecam.",
//             "time": 1708189605
//         },
//         {
//             "author_name": "Patryk Kamiński",
//             "author_url": "https://www.google.com/maps/contrib/103777210371872656855/reviews",
//             "language": "pl",
//             "profile_photo_url": "https://lh3.googleusercontent.com/a/ACg8ocKosOp2xBT8qS76dWeLRoSsqYdsUIxQLuh90kAb62l-=s128-c0x00000000-cc-rp-mo-ba3",
//             "rating": 5,
//             "relative_time_description": "w ostatnim tygodniu",
//             "text": "Wpadłem z polecenia Książula. Lokal w fajnym klimacie, jedzenie smaczne, ceny sporo wyższe niż w zwyķłym chińczyku, ale za jakość trzeba płacić. Okreśił bym to chińczykiem w wydaniu restauracyjnym. Potrawy ze składników wysokiej jakości, podawane w zdrowszej w formie, niż klasyczni przedstawiciele tego gatunku z barów. Jak ktoś jest przejazdem warto wpaść, ale żeby specjalnie jechać to raczej nie uświadczymy jakiegoś duże efektu \"wow\". Jest ok 😉",
//             "time": 1709017285
//         },
//         {
//             "author_name": "Tomasz Michalczyk",
//             "author_url": "https://www.google.com/maps/contrib/106030808255332008407/reviews",
//             "language": "pl",
//             "profile_photo_url": "https://lh3.googleusercontent.com/a-/ALV-UjWGWrXy6qzsgtz7Mjuz_pJzGVethNLYZtHLF_p8iL-emYk=s128-c0x00000000-cc-rp-mo-ba5",
//             "rating": 3,
//             "relative_time_description": "miesiąc temu",
//             "text": "To co fajne to talerze i sztućce ekologiczne i tyle.\n\nMiejsce ma bardzo dobre opinie nie wiem czemu. Smak potraw nie jest wyjątkowy tylko podobny do wielu miejsc nawet tych \"gorszych\".\n\nCzemu nie ma metalowych sztućców w restauracji gdzie średnia cena dania to 45 zł?\n\nNa zdjęciach z tym papierem i zielonymi dodatkami wygląda ładnie.\n\nW smaku normalny chińczyk za 20 zł\nZamówiłem dwa różne dania które miały taki sam smak sosu tylko jeden miał dodatek papryczki...\n\nDeser mocno słaby suchy na tym samym oleju co ryba i kurczak.\n\nSosy dodatkowe mocno przeciętne.\n\nWystrój knajpy pomieszany jakby drewniany saloon w chińskim stylu robionym pod Polaka.\n\nKalmary najlepsze.\nSajgonki przeciętne\nRyż kleisty\nSurówka.... Ehhh\nŚrednio mocno srednio",
//             "time": 1705671589
//         },
//         {
//             "author_name": "Dawid Czajkowski",
//             "author_url": "https://www.google.com/maps/contrib/102231781865101685451/reviews",
//             "language": "pl",
//             "profile_photo_url": "https://lh3.googleusercontent.com/a-/ALV-UjVtko84pKwAc8221xm8EdmsoOkRFmawWZl2ZGFVQ-wVhyg=s128-c0x00000000-cc-rp-mo",
//             "rating": 5,
//             "relative_time_description": "2 miesiące temu",
//             "text": "Przy okazji wizyty w stolicy, zachęceni filmem Książula, wstąpiliśmy do tego lokalu. Duży ruch, na szczęście trafił się wolny stolik. Obsługa poinformowała nas o długim oczekiwaniu na dania , nawet do godziny. Dania dostaliśmy po max 20 minutach. Na start dostaliśmy gratisową herbatę. Pierwsze danie (pad thai) i już wiedzieliśmy, że nie będziemy żałować, danie pyszne, intensywne, idealnie zbalansowane, z krewetkami o idealnej konsystencji i mega wyraźnym smaku. Kurczak na chrupko po Tajsku - pyszny chrupki kurczak, nie tłusty , do tego pyszny makaron , sos i warzywa. Kaczka po seczuańsku, osobiście fanem smaku mięsa z kaczki nie jestem , ale mamie bardzo smakowało. Krewetki w tempurze - dobre , intensywne krewetki w delikatnym sosie na mleczku kokosowym. Sajgonki bardzo sycące, dużo mięsa. Zdecydowanie polecam",
//             "time": 1701629630
//         },
//         {
//             "author_name": "Marcin Oleksiak",
//             "author_url": "https://www.google.com/maps/contrib/110240371828903144497/reviews",
//             "language": "pl",
//             "profile_photo_url": "https://lh3.googleusercontent.com/a/ACg8ocKiuMtOl5aLn_nEj6Cy15j06lmfm_mpeJvW5vmPm9Jj=s128-c0x00000000-cc-rp-mo-ba5",
//             "rating": 4,
//             "relative_time_description": "2 tygodnie temu",
//             "text": "Zupa Tom Yum bardzo mało wyrazistą. Kaczka po seczułańsku sucha, słodka bardzo słaba. Kurczak generała Tso i kurczak Pekin dobre tylko też za długo poddane obróbce termicznej. Udon z krewetkami poprawnie przygotowany, trochę mało wyrazisty. Banan w cieście dobry. Pieczarki w wwszystkich daniach. Warzyw mało. Głównie papryka czerwona i pieczarki. Trochę cebuli. Nie mogę powiedzieć, że to było strasznie słabe. Jednak raczej drugi raz nie odwiedzę. Księżulo proponuję odwiedzić Baodiep w Wyszkowie.",
//             "time": 1707857911
//         }
//     ],
//     "types": [
//         "meal_takeaway",
//         "restaurant",
//         "food",
//         "point_of_interest",
//         "establishment"
//     ],
//     "url": "https://maps.google.com/?cid=1182176134881335820",
//     "user_ratings_total": 1831,
//     "utc_offset": 60,
//     "vicinity": "Estrady 13D, Warszawa",
//     "website": "https://chinczyknaestrady.pl/12435?utm_source=google&utm_medium=mybusiness&utm_campaign=gb",
//     "html_attributions": [],
//     "utc_offset_minutes": 60
// }

// ChIJRxltNP-1HkcRDNqLZe7uZxA
</script>

<style>
.map {
  height: 400px; /* Ustaw wysokość mapy */
  width: 100%; /* Ustaw szerokość mapy */
}

.controls {
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid transparent;
  border-radius: 7px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  height: 36px;
  margin-left: 17px;
  margin-top: 10px;
  outline: none;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
}
</style>
